module.exports = __webpack_public_path__ + "img/nozx.883b6ad9.png";